import { EMPTY_FILTERS, ROOT_GROUP_ID } from "./constants";
import { PERIOD_PRESETS } from "./ViewDialog/CompactViewForm";

export const normalizeStatusId = (id) => String(id);

export const parseStatusIdsForQuery = (ids) =>

  ids.map((id) => parseInt(id, 10)).filter((id) => !Number.isNaN(id));

// Parsar settings-JSON från backend till filters-objekt
export const parseViewSettings = (settings) => {
  if (!settings) return null;
  try {
    return JSON.parse(settings);
  } catch {
    return null;
  }
};

export const getViewFilters = (view) => {
  const parsed = parseViewSettings(view?.settings).filters;

  let fromDate = null;
  let toDate = null;

  if (parsed.periodPreset === PERIOD_PRESETS.LAST_7_DAYS) {
    toDate = new Date();
    fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 7);
  } else if (parsed.periodPreset === PERIOD_PRESETS.LAST_30_DAYS) {
    toDate = new Date();
    fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);
  } else if (parsed.periodPreset === PERIOD_PRESETS.CUSTOM) {
    fromDate = parsed.orderDateFrom;
    toDate = parsed.orderDateTo;
  }

  return {
    supplierOrderStatusIds:
      parsed?.supplierOrderStatusIds ?? EMPTY_FILTERS.supplierOrderStatusIds,
    productTypes: parsed?.productTypes ?? EMPTY_FILTERS.productTypes,
    fromDate: fromDate ?? EMPTY_FILTERS.dateFrom,
    toDate: toDate ?? EMPTY_FILTERS.dateTo,
    deliveryDateFrom:
      parsed?.deliveryDateFrom ?? EMPTY_FILTERS.deliveryDateFrom,
    deliveryDateTo:
      parsed?.deliveryDateTo ?? EMPTY_FILTERS.deliveryDateTo,
    orderingCompanyIds:
      parsed?.orderingCompanyIds ?? EMPTY_FILTERS.orderingCompanyIds,
    orderStatus: parsed?.orderStatus,
  };
};

// Serialiserar filters till settings-sträng som skickas till backend
export const createViewFiltersPayload = (filters) =>
  JSON.stringify({
    supplierOrderStatusIds: filters.supplierOrderStatusIds ?? [],
    productTypes: filters.productTypes ?? [],
    dateFrom: filters.dateFrom ?? null,
    dateTo: filters.dateTo ?? null,
    deliveryDateFrom: filters.deliveryDateFrom ?? null,
    deliveryDateTo: filters.deliveryDateTo ?? null,
    orderingCompanyIds: filters.orderingCompanyIds ?? [],
  });

export const findViewById = (views, viewId) =>
  views.find((v) => v.id === viewId) ?? null;

export const findFirstView = (views) => views[0] ?? null;

export const isRootViewTarget = (groupId) =>
  !groupId || groupId === ROOT_GROUP_ID;

export const buildHitsLabel = (intl, count, activeFilterCount) => {
  if (!count) return intl.formatMessage({ id: "incomingOrders.views.noResults" });

  const orderWord = count === 1
    ? intl.formatMessage({ id: "incomingOrders.views.order" })
    : intl.formatMessage({ id: "incomingOrders.views.orders" });

  const filterPart = activeFilterCount > 0
    ? ` · ${activeFilterCount} ${intl.formatMessage({ id: "incomingOrders.views.filters" })}`
    : "";

  return intl.formatMessage(
    { id: "incomingOrders.views.foundOrders" },
    { count, orderWord, filterPart }
  );
};